import { IRequestService } from '..';
import { IntegrityIssue } from '../../models';

export interface IModelIntegrityService {
    getAll(): angular.IPromise<IntegrityIssue[]>;
}

export class ModelIntegrityService implements IModelIntegrityService {
    static serviceId = 'modelIntegrityService';

    static $inject = ['requestService'];

    private readonly _controllerUrl = 'model/integrity';

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<IntegrityIssue[]> {
        // always cleancache to get new data
        this._requestService.cleanCacheAtV1(this._controllerUrl);
        return this._requestService.getAtV1<IntegrityIssue[]>(this._controllerUrl);
    }
}